import {Row} from '../../components/Row';
import React, {memo, ReactNode, useEffect, useMemo} from 'react';
import {Container} from '../../components/Container';
import {useDispatch, useSelector} from "react-redux";
import {Column} from "../../components/Column";
import {Widget} from "../../components/Widget";
import {AreaModel} from "../../store/control/state";
import {useLocation} from 'react-router-dom';
import {useParams} from "react-router-dom";
import {Control} from "../../components/ItemList/control";
import {backButtonToggle, groupSettingAction, scenarioSettingAction} from "../../store/ui/actions";
import {Link} from "../../components/Link";
import {setGroupControlsAction} from "../../store/control/actions";
import {Configs} from '../../configs';
import {Media} from '../../components/Controls/AirConditionerControl';

const AreaButton = memo(function AreaButton({
                                            area,
                                            children,
                                        }: { area?: AreaModel, children?: ReactNode }) {
    return (
        <Column min={3} max={6}>
            <Widget style={{padding: 0}}>
                <Link icon={Configs.IMAGE_PREFIX+`${area.icon_type}`} title={area.name} to={`/area/${area.id}`}>
                    {children}
                </Link>
            </Widget>
        </Column>
    );
});

export const AreaScreen = memo(function AreaScreen() {
    const location = useLocation();
    const dispatch = useDispatch();
    //@ts-ignore
    const {id} = useParams();
    let allAreaList = useSelector(state => state.control.areaList);
    const allControlList = useSelector(state => state.control.controlList);
    const allMediaList = useSelector(state => state.control.mediaList)
    const parentArea = allAreaList.find((item) => item.id === (id ? id : ''));
    const areaList = allAreaList.filter(item => item.parent_area_id === (id ? id : ''));
    const controlList = useMemo(
        () =>
            allControlList
                .sort((a, b) => {
                    if (a?.parameters?.["order"] > b?.parameters?.["order"]) return 1;
                    if (a?.parameters?.["order"] < b?.parameters?.["order"]) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                    return 0;
                }).filter(c => c.area_id === id),
        [allControlList, id]
    )
    const mediaList = allMediaList.filter(c => c.area_id === id)
    useEffect(() => {
        if (parentArea) {
            dispatch(backButtonToggle({is_open: true, to: '/area/' + parentArea.parent_area_id}));
            if (controlList && controlList.length > 0) {
                dispatch(groupSettingAction({visible: true}));
                dispatch(scenarioSettingAction({visible: false}));
                dispatch(setGroupControlsAction(controlList));
            } else {
                dispatch(groupSettingAction({visible: false}));
                dispatch(scenarioSettingAction({visible: true}));
            }
        } else {
            dispatch(backButtonToggle({is_open: true, to: '/'}));
            dispatch(groupSettingAction({visible: false}));
            dispatch(scenarioSettingAction({visible: true}));
        }
    }, [location, controlList, dispatch, parentArea, mediaList]);
    return (
        <Container>
            <div className="page-wrapper">
                <Row>
                    {
                        areaList && areaList.map((area, index) => (
                                <AreaButton area={area} key={index}/>
                            ),
                        )
                    }
                </Row>
                <Row>
                    {
                        ((controlList && controlList.length > 0) && (areaList && areaList.length > 0)) ?
                            <div className='divider'/> : null
                    }
                    {
                        controlList && controlList.map((item) => (
                            <Control key={`control_${item.id}`}
                                     control={item}/>
                        ))
                    }
                </Row>
                <Row>
                    {
                        mediaList && mediaList.map((media) => (
                           <Media media={media} key={`media_${media.id}`} />
                        ))
                    }
                </Row>
            </div>
        </Container>
    );
});
